// extracted by mini-css-extract-plugin
export default {"price":"v8-z","onSale":"w8-z","msrpLabelPrice":"x8-z","msrpLabel":"y8-z","originalPrice":"z8-z","percentOff":"A8-z"};